import script from "./AIChatAssistant.vue?vue&type=script&setup=true&lang=js"
export * from "./AIChatAssistant.vue?vue&type=script&setup=true&lang=js"

import "./AIChatAssistant.vue?vue&type=style&index=0&id=773e440e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-773e440e"]])

export default __exports__